export default __webpack_public_path__ + "static/media/sticker-T.9f44bb5e.png";